import { postRequest } from "../../config/AxiosConfig";
import API_URLS from "../../config/BackendConfig";
import { getAuthToken } from "../../utils/tokenUtils";


// Add News
export const AddNewsService = async (news,scope,ColorCode) => {
    try {
        const token = getAuthToken();  
        const response = await postRequest({
            url: API_URLS.ADMIN + 'news/create',
              data: {
                news,     
                scope,
                ColorCode
            }, 
            headers: {
                'Authorization': `Bearer ${token}`, 
            },
        });
        return response;  
    } catch (error) {
        console.error(error);  
        return error;  
    }
};


 // Fetch News Reports Services
export const fetchNews = async (page = 1) => {
    try {
        const token = getAuthToken();
        const response = await postRequest({
        url: `${API_URLS.ADMIN}news/report?page=${page}`,
        headers: {
            'Authorization': `Bearer ${token}`
        },
    });
    //console.log(response);
    return response
} catch (error) {
    return error;
}}
// ENd


// Edit Route Details Service
export const editNewsDetails = async ({ news_id }) => {
    try {
      const token = getAuthToken();
      const response = await postRequest({
        url: API_URLS.ADMIN + "news/edit",
        data: { news_id },
        headers: { Authorization: `Bearer ${token}` },
      });
     // console.log("News",response);
      return response;
    } catch (error) {
      console.error("Error fetching edit News details:", error);
      throw error;
    }
  };
  
  export const updateNewsDetails = async ({ payload, news_id }) => {
    try {
      const token = getAuthToken(); 
      const response = await postRequest({
        url: `${API_URLS.ADMIN}news/update`, 
        data: { news_id, ...payload }, 
        headers: { Authorization: `Bearer ${token}` },
      });
     // console.log("Update News Response:", response);
      return response;
    } catch (error) {
      console.error("Error updating News:", error);
      throw error;
    }
  };

// Delete News Service
export const deleteNews = async (news_id) => {
    try {
        const token = getAuthToken();
        const response = await postRequest({
            url: `${API_URLS.ADMIN}news/delete`,
            data: { news_id },
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        //console.log("Delete News Response:", response);
        return response;
    } catch (error) {
        console.error("Error deleting News:", error);
        throw error;
    }
};
  

  